// extracted by mini-css-extract-plugin
export default {"pp":"pp","pp_title":"pp_title"};